import { MINCOL } from "../../../constants/const";
import ClickableCell from "../ClickableCell";
import DropdownFilter from "../SD_einsehen/DropdownFilter";

export const linienverlaufHeader = [
    {
        accessor: 'id',
        Header: 'ID'
    },
    {
        accessor: 'id_linie',
        Header: 'ID Linie'
    },
    {
        accessor: 'linie',
        Header: 'Linie',
        width: '12em',
        Filter: DropdownFilter
    },
    {
        Header: 'Hinrichtung',
        columns: [
            {
                accessor: 'id_strecke_hr',
                Header: 'ID Strecke'
            },
            {
                accessor: 'verlauf_hr',
                Header: 'Verlauf_Hin'
            },
            {
                accessor: 'halt_hr',
                Header: 'Halt_Hin',
                Cell: ClickableCell
            },
        ]
    },
    {
        Header: 'Rückrichtung',
        columns: [
            {
                accessor: 'id_strecke_rr',
                Header: 'ID Strecke'
            },
            {
                accessor: 'verlauf_rr',
                Header: 'Verlauf_Rück'
            },
            {
                accessor: 'halt_rr',
                Header: 'Halt_Rück',
                Cell: ClickableCell
            },
        ]
    },
    {
        Header: 'Gültigkeit',
        columns: [
            {
                accessor: 'gueltig_von',
                Header: 'von'
            },
            {
                accessor: 'gueltig_bis',
                Header: 'bis'
            }
        ]
    },
    // für Spaltenbreite:
    {
        Header: 'Halt_Hin',
        unused: true,
        width: '12em'
    },
    {
        Header: 'Halt_Rück',
        unused: true,
        width: '12em'
    },
    {
        Header: 'Verlauf_Hin',
        unused: true,
        width: '15em'
    },
    {
        Header: 'Verlauf_Rück',
        unused: true,
        width: '15em'
    },
    {
        Header: 'von',
        unused: true,
        width: MINCOL
    },
    {
        Header: 'bis',
        unused: true,
        width: MINCOL
    },
]